import { sso } from "roboflex-thalamus-sso-lib";

export let userLoggedIn = sso.getUsuarioLogado();
